import { ObjectType } from '@/shareds/types';

export const getValues = (resourceData: ObjectType, objectName?: string): ObjectType =>
  ((objectName ? resourceData?.[objectName] : resourceData) || {}) as ObjectType;
